// import icon01 from '@/assets/01.svg' //
import icon02 from '@/assets/02.svg' //
import icon03 from '@/assets/03.svg' //
// import icon04 from '@/assets/04.svg' //
// import icon05 from '@/assets/05.svg' // что вас
import icon06 from '@/assets/06.svg' // 7 проблем
// import icon07 from '@/assets/07.svg' // 
import icon08 from '@/assets/08.svg' // для кого
import icon09 from '@/assets/09.svg' // врачам
export default [
    {
        title: 'Увеличьте доход клиники и снимите все барьеры на пути к потоку пациентов!',
    },
    {
        title: 'Добро пожаловать на конференцию, которая откроет перед вами новые возможности для роста и развития вашей клиники.',
    },
    {
        // title: 'Врачам',
        title: 'Что врачи узнают на этой конференции?',
        icon: icon09,
        show: true,
        collapse: false,
        list: [
            // ['','От невидимости к славе: как превратить своё имя в маяк успеха и стать лидером в своей нише.'],
            // ['','Пациенты сами просят контакты? Это реально! Создайте имя, которое работает на вас и приносит стабильный поток пациентов.'],
            // ['','Секреты популярности: как стать косметологом, которого выбирают на эмоциях, а не по цене.'],
            // ['','Почему пациенты запоминают одних косметологов и забывают других? Узнайте, как оставить яркий след.'],

            ['','Как заполнять запись на месяц вперед.'],
            ['','Какой контент создавать, чтобы привлекать пациентов.'],
            ['','Как построить своё продвижение, которое выделит вас среди других.'],
            ['','Как использовать Telegram для продвижения своих услуг.'],
            ['','Почему для врача важны отзывы на геосервисах.'],
            ['','Как врачу вести сообщество во ВКонтакте для своего продвижения.'],
            ['','Важность персонального блога в привлечении пациентов.'],
            ['','ИИ как неотъемлемый инструмент для продвижения своей практики.'],
            ['','Как врачу оформить карточку в агрегаторах, чтобы пациенты выбирали именно вас.'],
        ],
    },
    {
        title: 'Конференция разделена на 4 блока:',
        icon: icon03,
        show: false,
        collapse: true,
        list: [
            ['Отстройка от конкурентов',' — получите проверенные практики и инструменты, чтобы врач, клиника стала заметнее и убедительнее на фоне других. Узнаете, как за счёт уникального подхода и точных методов маркетинга повысить доверие к Вашему бренду и увеличить лояльность пациентов.'],
            ['Максимальная видимость в интернете',' — Вы узнаете, как вывести личный бренд врача, клинику на лидирующие позиции в интернете через SEO, социальные сети и агрегаторы. Мы покажем, какие шаги позволят сделать Ваш бренд, Вашу клинику заметной и востребованной.'],
            ['Управление репутацией',' — научитесь формировать положительный имидж врача, клиники и управлять отзывами, чтобы создать рейтинг 5.0. Мы обсудим, как эффективно работать с отзывами и укреплять доверие, которое так важно в медицинской сфере.'],
            ['Эффективность рекламы',' — узнаете, как каждая вложенная в рекламу сумма может приносить многократную отдачу. Мы расскажем, как настроить рекламу так, чтобы каждый рубль работал максимально эффективно и приносил результат.'],
        ],
    },
    {
        title: 'Для кого эта конференция?',
        icon: icon08,
        show: false,
        collapse: true,
        list: [
            ['Врачи, развивающие личный бренд',' — если Вам важно укреплять профессиональный имидж и привлекать больше пациентов, то здесь Вы найдете подходящие инструменты и узнаете, как использовать их на практике.'],
            ['Маркетологи и специалисты по продвижению',' — для тех, кто хочет освоить актуальные маркетинговые стратегии и повысить свои результаты, делая клинику более узнаваемой и востребованной.'],
            ['Руководители и владельцы клиник',' — если Вы хотите увеличить прибыль клиники и привлечь больше пациентов, то эта конференция для Вас. Мы покажем, как оптимизировать маркетинг и управление репутацией для повышения доходов и эффективности.'],
        ],
    },
    {
        title: 'Решаем 7 болей',
        show: false,
        collapse: true,
        icon: icon06,
        list: [
            [ 'Операционка', ': как выбраться из рутины и сосредоточиться на стратегии'],
            [ 'Объективная оценка', ': где найти честного советчика и поддержку'],
            [ 'Ломаем барьеры', ': как заменить комплименты на конструктивную критику'],
            [ 'Трата времени на обучение', ': когда тренинги не приносят результатов'],
            [ 'Фокус на главном', ': вырабатываем приоритеты и увеличиваем результативность'],
            [ 'Управление изменениями', ': развиваем личную ответственность для прорыва'],
            [ 'Раздвигаем горизонты', ': принимаем правду и становимся лучше'],

            // ['Операционный капкан',': как выбраться из рутины и сосредоточиться на стратегии'],
            // ['Одиночество руководителя',': где найти честного советчика и поддержку'],
            // ['Ломаем барьеры',': как заменить комплименты на конструктивную критику'],
            // ['Пустая трата времени на обучение',': когда тренинги не приносят результатов в бизнесе'],
            // ['Фокус на главном',': вырабатываем приоритеты и увеличиваем результативность'],
            // ['Управление изменениями',': развиваем личную ответственность для прорыва'],
            // ['Страх критики',': принимаем правду и становимся лучше'],
        ],
    },
    {
        title: 'Что вы получите?',
        icon: icon02,
        show: false,
        collapse: true,
        list: [
            ['Готовые схемы ', ' — четкие и проверенные шаги, которые можно сразу внедрить для развития личного бренда, в работу Вашей клиники. Это будут понятные инструкции, позволяющие быстро добиваться результатов.'],
            ['Практические кейсы ',' — реальные примеры и истории врачей, клиник, которые смогли увеличить поток пациентов и доход.'],
            ['Мощные инструменты для роста и выхода из кризиса',' — узнаете, какие инструменты и стратегии позволяют врачам и клиникам развиваться даже в сложных экономических условиях и становиться лидерами в своей нише.'],
        ],
    },
    // {
    //     title: 'Нетворкинг',
    //     icon: icon04,
    //     show: true,
    //     collapse: false,
    //     list: [
    //         ['','После конференции у вас будет уникальная возможность пообщаться с докладчиками лично и задать им интересующие вас вопросы. Узнайте больше о представленных стратегиях, уточните детали для внедрения в вашей клинике и получите советы, основанные на реальном опыте экспертов. Это ваш шанс получить ответы от ведущих специалистов отрасли и обсудить идеи, которые помогут вывести вашу клинику на новый уровень.'],
    //         [ '','', {
    //             title: 'Эксперты:',
    //             list: [
    //                 'Оценят текущее положение дел и выявят ошибки',
    //                 'Внимательно выслушают Ваши проблемы и помогут определить Вашу готовность к изменениям в продвижении',
    //                 'Нарисуют дорожную карту. Вместе мы разработаем стратегию продвижения клиники под Ваши запросы',
    //             ]
    //         } ],
                
    //     ],
    // },
    {
        title: 'На нашей конференции нет нерешаемых вопросов — есть незаданные!',
    },
]